import { ThemeProvider } from "@mui/material";
import { heyvetTheme } from "./theme/heyvetTheme";
import HeyVetLayoutPage from "./components/HeyVetLayoutPage";

// Import the specific CSS file for Hey Vet
import "./css/heyvet.css";

export default function HeyVetApp() {
    return (
        <ThemeProvider theme={heyvetTheme}>
            <HeyVetLayoutPage />
        </ThemeProvider>
    );
}
